import * as React from 'react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from './components/ui/collapsible.js';

export function DimeCollapsible({ ...props }: Readonly<React.ComponentProps<typeof Collapsible>>) {
  return <Collapsible {...props} />;
}

export function DimeCollapsibleTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof CollapsibleTrigger>>) {
  return <CollapsibleTrigger {...props} />;
}

export function DimeCollapsibleContent({
  ...props
}: Readonly<React.ComponentProps<typeof CollapsibleContent>>) {
  return <CollapsibleContent {...props} />;
}
